import { HttpErrorResponse, HttpEvent, HttpHandler, HttpInterceptor, HttpRequest } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Router } from '@angular/router';
import { Observable, throwError } from 'rxjs';
import { catchError, switchMap } from 'rxjs/operators';
import { AuthService } from '../auth/auth.service';

@Injectable()
export class AuthInterceptor implements HttpInterceptor {
    constructor(private authService: AuthService, private router: Router) { }

    // intercept(req: HttpRequest<any>, next: HttpHandler): Observable<HttpEvent<any>> {
    //     return this.authService.getToken().pipe(
    //         switchMap((token) => {
    //             if (token) {
    //                 // Clone the request and add the token to the headers
    //                 const cloned = req.clone({
    //                     setHeaders: {
    //                         Authorization: `Bearer ${token}`
    //                     }
    //                 });
    //                 return next.handle(cloned);
    //             } else {
    //                 // Redirect to login page if no token is found
    //                 localStorage.removeItem('sso_token');
    //                 localStorage.removeItem('ltts');
    //                 localStorage.removeItem('PROFILE_DETAILS');
    //                 localStorage.removeItem('SESSION');
    //                 localStorage.removeItem('CALENDAR_TOKEN');
    //                 this.router.navigate(['/login']);
    //                 return throwError(() => new Error('Token not found'));
    //             }
    //         }),
    //         catchError((error: HttpErrorResponse) => {
    //             if (error.status === 401 || error.status === 403) {
    //                 // Redirect to login page on unauthorized or forbidden error
    //                 localStorage.removeItem('sso_token');
    //                 localStorage.removeItem('ltts');
    //                 localStorage.removeItem('PROFILE_DETAILS');
    //                 localStorage.removeItem('SESSION');
    //                 localStorage.removeItem('CALENDAR_TOKEN')

    //                 this.router.navigate(['/login']);
    //             }
    //             return throwError(() => error);
    //         })
    //     );
    // }
    intercept(req: HttpRequest<any>, next: HttpHandler): Observable<HttpEvent<any>> {
        return next.handle(req).pipe(
          catchError((error: HttpErrorResponse) => {
            // Check if error status is 401 (Unauthorized)
            if (error.status === 401 || error.status === 403) {
              // Clear local storage
              localStorage.clear();

              // Redirect to login page
              this.router.navigate(['/home']);
            }

            // Rethrow the error for further handling if needed
            return throwError(error);
          })
        );
      }
}
